module.exports = __webpack_public_path__ + "img/RFID.0086a458.png";